<template>
  <div class="form__group form__group--move" :class="getInstanceClass()">
    <div class="form__input" :class="isFocused()">
      <textarea
        :id="id"
        :required="required"
        :placeholder="placeholder"
        :value="currentValue.valueOf()"
        autocomplete="off"
        @input="updateValue($event)"
        @focus="onChange"
        @blur="onBlur"
        :disbabled="disabled"></textarea>
    </div>
    <label :for="id">{{ label }}</label>
  </div>
</template>
<script lang="ts" setup>
  import { ref, onMounted, PropType, watch } from 'vue'
  import { ValidatorObject } from '../../types/types'

  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    validators: {
      type: Array as PropType<Array<ValidatorObject>>,
      default: [],
      validator (value : Array<ValidatorObject>) {
        value.forEach(vld => {
          if (
            !Object.hasOwnProperty.call(vld, 'validate') ||
            typeof vld.validate !== 'function' ||
            !Object.hasOwnProperty.call(vld, 'message') ||
            typeof vld.message !== 'string'
          ) {
            return false
          }
        })
        return true
      }
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      default: ''
    },
    staticlabel: {
      type: Boolean,
      staticLabel: false
    },
    domclass: {
      type: String,
      domclass: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    }
  })

  const emits = defineEmits([
    'update:modelValue',
    'blur',
    'focus',
    'setHeight'
  ])

  const currentValue = ref<String>('')
  const hasFocus = ref<Boolean>(false)
  const errors = ref<Array<any>>([])

  onMounted (() => {
    currentValue.value = props.modelValue
  })

  watch(props, () => {
    currentValue.value = props.modelValue
  })

  const getInstanceClass = () => {
    return [
      props.domclass,
      errors.value.length > 0 ? 'form__group--error' : '',
      props.modelValue ? 'form__group--touched' : '',
      !props.staticlabel || props.modelValue ? 'form__group--move' : ''
    ].join(' ')
  }

  const isFocused = () => {
    return hasFocus.value ? 'form__input--focus' : ''
  }

  const onBlur = () => {
    hasFocus.value = false
    if (currentValue.value) {
      props.validators.forEach(val => {
        const input = currentValue.value as string
        if (!val.validate(input)) {
          errors.value.push(val.message)
          emits('setHeight')
        }
      })
    }
    emits('blur')
  }

  const onChange = () => {
    emits('focus')
    errors.value = []
    hasFocus.value = true
  }

  const updateValue = (event : Event) => {
    const inputEl = event.target as HTMLInputElement
    currentValue.value = inputEl.value
    emits('update:modelValue', inputEl.value, props.id)
  }

</script>